export default class InternalStakeholderDefinition {
    constructor(id) {
        this._id = id;
    }

    get id() {
        return this._id;
    }
}